<template>
    <ModalComponent
        name="perfilModal"
        title="Editar información"
        @close="$emit('close', false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
            <b-row v-if="localData">
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="localData.name"
                        id="nombre"
                        rules="required"
                        :label="$t('formularios.nombre')"
                        :name="$t('formularios.nombre')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="localData.lastName"
                        rules="required"
                        id="apellidos"
                        :label="$t('formularios.apellidos')"
                        :name="$t('formularios.apellidos')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <ValidationProvider name="genero" rules="required" v-slot="{ errors }">
                        <div class="form-group">
                            <label>{{ $t('formularios.genero') }}</label>
                            <multiselect
                                v-model="localData.gender_object"
                                label="name"
                                track-by="id"
                                class="custom-multiselect"
                                :class="(errors[0] ? 'is-invalid' : '')"
                                id="genero"
                                :placeholder="$t('formularios.genero')"
                                :options="generos"
                                @select="formatGender"
                            />
                            <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold" >
                                {{ errors[0] }}
                            </span>
                        </div>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6" lg="6">
                    <DocumentoTipo
                        :value="localData.identification.type"
                        :index="1"
                        @input="val => { localData.identification.type = val; }"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="6">
                    <DocumentoValor
                        :type="localData.identification.type"
                        :value="localData.identification.value"
                        :index="1"
                        @input="val => { localData.identification.value = val; }"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <Paises
                            ref="paises"
                            :pais="pais?.iso3 ? pais : null"
                            :desactivar="false"
                            @paisesCargados="onPaisesCargados"
                            @rellenarPais="rellenarPais"
                            @selected="opt => { pais = opt; localData.address.country = opt.iso3; }"
                        />
                    </div>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <Provincias
                            ref="provincias"
                            :desactivar="false"
                            :pais="pais.id"
                            :provincia="provincia"
                            @provinciasCargadas="onProvinciasCargadas"
                            @selected="opt => { provincia = opt; localData.address.state = opt.nombre; }"
                        />
                    </div>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <Locations
                            :localidad="localidad"
                            :desactivar="false"
                            :provincia="provincia"
                            @localidadesCargadas="onLocalidadesCargadas"
                            @selected="opt => { localData.address.city = opt.nombre; }"
                        />
                    </div>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="localData.address.zipCode"
                        rules="required"
                        id="cp"
                        :label="$t('formularios.cp')"
                        :name="$t('formularios.cp')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="localData.address.streetLine1"
                        rules="required"
                        id="direccion"
                        :label="$t('formularios.domicilio')"
                        :name="$t('formularios.domicilio')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="localData.birthday"
                        rules="required"
                        id="fecha-nacimiento"
                        type="date"
                        :label="$t('formularios.nacimiento')"
                        :name="$t('formularios.nacimiento')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="6">
                    <div class="form-group">
                        <label for="telefono">{{ $t('formularios.telefono') }}</label>
                        <PhoneInput
                            name="telefono" 
                            :phone="localData.phone ?? null" 
                            :required="true"
                            :error_telefono="localData.error_telefono"
                            @setNumber="(number) => localData.phone = number"
                            @validNumber="(valid) => localData.isValidNumber = valid"
                        />
                    </div>
                </b-col>
                <b-col cols="12" md="6" lg="6">
                    <FormInput
                        v-model="localData.email"
                        rules="required"
                        id="email"
                        type="email"
                        :label="$t('formularios.email')"
                        :name="$t('formularios.email')"
                        disabled
                    />
                </b-col>
                <b-col cols="12" class="m-3">
                    <hr/>
                </b-col>
                <b-col cols="12">
                    <b-button type="submit">
                        Editar datos
                    </b-button>
                </b-col>
            </b-row>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import Generos from "@/mixins/Generos";
    import Provincias from "../../../../common/forms/Provincias";
    import Locations from "../../../../common/forms/Locations";
    import Paises from "../../../../common/forms/Paises";
    import PhoneInput from '@/components/common/PhoneInput';
    import DocumentoTipo from "@/components/common/DocumentoTipo";
    import DocumentoValor from "@/components/common/DocumentoValor";

    export default {
        mixins: [Generos],
        name: "EditarPerfil",
        props: {
            perfil: {
                type: Object,
                required: true
            }
        },
        components: {
            ModalComponent, Provincias, Locations, Paises, PhoneInput, DocumentoTipo, DocumentoValor
        },
        data() {
            return {
                loading: false,
                localData: { ...this.perfil},
                provincia: null,
                localidad: null,
                pais: { id: 0 },
                enviando: false
            }
        },
        created() {
            this.getGeneros();
            this.localData.identification.type = 'DNI';
        },
        methods: {
            rellenarPais(pais) {
                this.localData.address.country = pais.iso3;
            },
            onPaisesCargados(paises) {
                if (this.localData.address.country) {
                    const encontrado = paises.find(p => p.iso3 === this.localData.address.country);
                    this.pais = encontrado || { id: 0 };
                }
            },
            onProvinciasCargadas(provincias) {
                if (this.localData.address.state) {
                    const encontrado = provincias.find(p => p.nombre === this.localData.address.state);
                    this.provincia = encontrado || null;
                }
            },
            onLocalidadesCargadas(localidades) {
                if (this.localData.address.city) {
                    const encontrado = localidades.find(l => l.nombre === this.localData.address.city);
                    this.localidad = encontrado || null;
                }
            },
            formatGender(option) {
                switch (option.name) {
                    case 'Hombre':
                        this.localData.gender = 'MALE';
                        break;
                    case 'Mujer':
                        this.localData.gender = 'FEMALE';
                        break;
                    default:
                        this.localData.gender = 'OTHER';
                        break;
                }
            },
            async submit() {
                const observerRefs = this.$refs;
                let isValid = await this.$refs.observer.validate();

                if (isValid) {
                    this.editarPerfil();
                }                
            },
            editarPerfil() {
                if (this.enviando) return;

                this.enviando = true;

                const params = { ...this.localData };

                params.profile_id = this.localData.id;

                this.$store.dispatch(this.config.getVuexAlias("front.perfil.sga.update"), params).then(res => { 
                    this.$toast.success('Datos actualizados correctamente');
                    this.$emit('close', true);
                }).finally(() => {
                    this.enviando = false;
                });
            } 
        }
    }
</script>